import * as actions from "./actionsTypes";

const initialData = {
  loaderMetricaCompetencia: false,
  metricaCompetencia: null,
  metricaCompetenciaFalla: null,
  saveLoaderMetricaCompetencia: false,
  metricaCompetenciaFormError: null,
  ultimoRegistro: null,
  loaderUltimoRegistro: false,
};

export default function MetricaCompetenciaReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_METRICA_POR_COMPETENCIA:
      return { ...state, loaderMetricaCompetencia: action.payload };

    case actions.GET_METRICA_POR_COMPETENCIA:
      return { ...state, metricaCompetencia: action.payload };

    case actions.METRICA_POR_COMPETENCIA_FALLA:
      return { ...state, metricaCompetenciaFalla: action.payload };

    case actions.SAVE_LOADER_METRICA_POR_COMPETENCIA:
      return { ...state, saveLoaderMetricaCompetencia: action.payload };

    case actions.FORM_METRICA_POR_COMPETENCIA_FAIL:
      return { ...state, metricaCompetenciaFormError: action.payload };

    case actions.GET_ULTIMO_REGISTRO:
      return { ...state, ultimoRegistro: action.payload };

    case actions.LOADER_ULTIMO_REGISTRO:
      return { ...state, loaderUltimoRegistro: action.payload };

    default:
      return state;
  }
}
